export function ErrorHandler() {
    this.onErrorCode = null;
    this.onError500 = null;
    this.onError400 = null;
    this.onError401 = null;
    this.onError412 = null;
    this.onError409 = null;
    this.onErrorDefault = null;

    this.alertModal = null;
    this.noInternetModal = null;

    this.setAlertModal = function(alertModal) {
        this.alertModal = alertModal;
    };
    this.showAlert = function(msg) {
        if (this.alertModal != null) {
            this.alertModal
                .clearModal()
                .setMsg(msg)
                .show();
        }
    };
    this.setNoInternetModal = function (noInternetModal) {
        this.noInternetModal = noInternetModal;
    };
    this.showNoInternet = function (msg) {
        if (this.noInternetModal != null) {
            this.noInternetModal
                .clearModal()
                .setMsg(msg)
                .show();
        }
    };

    this.errorCase = function(err) {
        switch (err.id) {
            case 500:
                this.error500(err);
                break;
            case 400:
                this.error400(err);
                break;
            case 401:
                this.error401(err);
                break;
            case 409:
                this.error409(err);
                break;
            case 412:
                this.error412(err);
                break;
            default:
                this.errorDefault(err);
        }
    };

    this.errorCode = function(err) {
        console.log('error code:', err);
        if (typeof this.onErrorCode == 'function') {
            this.onErrorCode();
        }
    };

    this.error500 = function(err) {
        if (typeof this.onError500 == 'function') {
            this.onError500(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error400 = function(err) {
        if (typeof this.onError400 == 'function') {
            this.onError400(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error401 = function(err) {
        if (typeof this.onError401 == 'function') {
            this.onError401(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error409 = function(err) {
        if (typeof this.onError409 == 'function') {
            this.onError409(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.error412 = function(err) {
        if (typeof this.onError412 == 'function') {
            this.onError412(err);
        } else {
            this.showAlert(err.message);
        }
    };
    this.errorDefault = function(err) {
        if (typeof this.onErrorDefault == 'function') {
            this.onErrorDefault(err);
        } else {
            this.showAlert("Connection Error");
        }
    };
}
